import React from "react";
import RoleForm from "./RoleForm";

export default function AddRole() {
  return <RoleForm type="Add" />;
}
